export const links = [
  {
    title: "dVPN Features",
    href: "/features",
    external: false,
  },
  {
    title: "dVPN Apps",
    href: "/dapps",
    external: false,
  },
  {
    title: "Run a Node",
    href: "https://docs.sentinel.co/node-setup",
    external: true,
  },
  {
    title: "Build a dVPN App",
    href: "https://docs.sentinel.co/sentinel-hub",
    external: true,
  },
  {
    title: "Learn",
    href: "https://docs.sentinel.co/",
    external: true,
  },
];

export const exploreLinks = [
  {
    title: "Network Statistics",
    href: "https://stats.sentinel.co/",
    external: true,
  },
  {
    title: "Node Dashboard",
    href: "https://nodes.sentinel.co/",
    external: true,
  },
  {
    title: "Node Map",
    href: "https://map.sentinel.co/",
    external: true,
  },
  {
    title: "Explorer",
    href: "https://explorer.sentinel.co/",
    external: true,
  },
];
